import axios from 'axios';
import store from '../../store/index';

export default {
	login(username, password, tenant) {
		let headers = {};
		if (tenant) {
			headers = {
				headers: {
					tenant,
				},
			};
		}
		return axios.post(
			'/api/auth/login/',
			{
				username,
				password,
				origin: 'web',
			},
			headers
		);
	},
	logout() {
		return axios.post('/api/auth/logout');
	},
	register(user, tenant) {
		let headers = {};
		if (tenant) {
			headers = {
				headers: {
					tenant,
				},
			};
		}
		return axios.post('/api/auth/signup/', user, headers);
	},
	requestPasswordReset(email, tenant) {
		return axios.post(
			'/api/auth/reset',
			{ email: email, frontend: 'Web' },
			{
				headers: {
					Tenant: tenant,
				},
			}
		);
	},
	validateToken() {
		return axios.get(`/api/sso`);
	},
	validateResetToken(token) {
		return axios.get(`/api/auth/reset?token=${token}`);
	},
	resetPassword(password, token, reset) {
		return axios.patch(`/api/auth/reset?token=${token}`, { password: password });
	},
	changePassword(password) {
		return axios.patch(`/api/users/me/password`, { password: password });
	},
	load() {
		return axios.get('/api/sso/');
	},
	async loadTenants() {
		return axios.get('/api/tenants');
	},
	async loadSignupAllowed(tenants) {
		return axios.post(
			`/api/setup/signupAllowed`,
			tenants.map((tenant) => tenant.value)
		);
	},
};
